import * as actionTypes from './actionTypes';
import {postData} from "../../shared/networkUtil";

export const getCouponRequest = () => ({
    type: actionTypes.GET_COUPON_REQUEST
});

export const getCouponSuccess = coupon => ({
    type: actionTypes.GET_COUPON_SUCCESS,
    coupon
});

export const getCouponError = error => ({
    type: actionTypes.GET_COUPON_ERROR,
    error
});

export const clearCoupon = () => ({
    type: actionTypes.CLEAR_COUPON
});

export const clearCouponOff = () => ({
    type: actionTypes.CLEAR_COUPON_OFF
});

export const getCoupon = (code, couponCheckRequest) => dispatch => {
    dispatch(getCouponRequest());
    postData(
        `/coupon/verify-code/${code}`,
        couponCheckRequest,
        response => {
            console.log(response);
            dispatch(getCouponSuccess(response.data));
        },
        error => {
            console.log(error);
            dispatch(getCouponError(error));
        }
    );
};

